export default __webpack_public_path__ + "static/media/icon_documents.ef01c15f.svg";